import api from './api';

// Brand-scoped key-value configuration, and the personal tokens its public endpoints
// authenticate with. The web routes below carry the active brand in X-Brand automatically.
//
// The token routes are the personal-credential kind (Settings page), like the Figma and
// Customer.io tokens. Scripts then name the brand as a query parameter, and the API re-checks
// the token owner's manage:configuration on that brand on every call:
//   curl -X PUT -H "Authorization: Bearer cfg_..." -d '{"key":"...","value":"..."}' \
//     "https://.../api/public/configuration?brand=bitstarz"
export const configurationAPI = {
  list: () => api.get('/api/configuration'),
  set: (body) => api.put('/api/configuration', body),
  listTokens: () => api.get('/api/configuration-tokens'),
  createToken: (body) => api.post('/api/configuration-tokens', body),
  revokeToken: (id) => api.delete(`/api/configuration-tokens/${id}`),
};

export default configurationAPI;
